import { MSConstant } from '@/commons/wildcards';
import i18nGlobal from '@/i18ns/i18n';
const i18n = i18nGlobal.global;
import { getCurrentInstance, ref, onMounted, watch } from 'vue';

function setup(props, { emit }) {
  // Variable
  const { proxy } = getCurrentInstance();
  // Ref data filterOperators
  const filterOperators = ref([]);

  // Giá trị ô filter
  const operatorValue = ref('');
  const operatorValueReadonly = ref(false);
  // Giá trị ô input => đặt bằng null để k trigger lần đầu khi chưa có filter
  const filterValue = ref(null);
  // ref ô input
  const filterInput = ref(null);

  // icon filter
  const nativeFilterIconClass = ref();

  const thEnum = ref({});

  // Method
  /**
   * Hàm set lại giá trị operator khi click thay đổi => đoạn này thêm xử lý đổi icon
   * @param {*} operator
   * HTHIEP 14.03.2022
   */
  const filterOperatorItemClick = operator => {
    switch (operator.enumKey) {
      case 'remove':
        // Xóa filter và set lại giá trị
        removeFilter();

        // Set lại icon
        nativeFilterIconClass.value = props.filterIconClass;
        break;
      default:
        nativeFilterIconClass.value = operator.icon;
        operatorValue.value = operator.enumValue;
        break;
    }

    // Trigger filter
    filterHeaderHandle({
      operator: operator.enumValue,
      value: proxy.filterValue,
    });
  };

  /**
   * Lấy type column, dùng xác định xem build filter dạng gì
   * @param {*} col
   * @return
   * HTHIEP 11.03.2022
   */
  const getColumnOptionType = col => {
    if (col.filterable === false) {
      return MSConstant.FormatType.None;
    } else if (col.enumName || col.enum) {
      return MSConstant.FormatType.Enum;
    }

    return col.formatType;
  };

  /**
   * Lấy dữ liệu cho cột dropdown operator
   * @param {*} col
   * @return
   * HTHIEP 11.03.2022
   */
  const getFilterData = col => {
    const filterTextData = [
      proxy?.$ms.constant.FilterOperator.Null,
      proxy?.$ms.constant.FilterOperator.NotNull,
      proxy?.$ms.constant.FilterOperator.Equals,
      proxy?.$ms.constant.FilterOperator.NotEquals,
      proxy?.$ms.constant.FilterOperator.Contains,
      proxy?.$ms.constant.FilterOperator.Notcontains,
      proxy?.$ms.constant.FilterOperator.StartsWith,
      proxy?.$ms.constant.FilterOperator.EndsWith,
    ];
    const columnType = getColumnOptionType(col);

    if (typeof columnType === 'undefined' || columnType == null) {
      return filterTextData;
    }

    switch (columnType) {
      case proxy.$ms.constant.FormatType.None:
        return [];
      case proxy.$ms.constant.FormatType.Enum:
        return [proxy?.$ms.constant.FilterOperator.Equals, proxy?.$ms.constant.FilterOperator.NotEquals];
      case proxy.$ms.constant.FormatType.Number:
      case proxy.$ms.constant.FormatType.UnitPrice:
      case proxy.$ms.constant.FormatType.Amount:
      case proxy.$ms.constant.FormatType.Rate:
      case proxy.$ms.constant.FormatType.ExchangeRate:
      case proxy.$ms.constant.FormatType.UnitPriceOC:
      case proxy.$ms.constant.FormatType.AmountOC:
      case proxy.$ms.constant.FormatType.Allocation:
      case proxy.$ms.constant.FormatType.QuantityConvert:
      case proxy.$ms.constant.FormatType.Quantity:
        return [
          proxy?.$ms.constant.FilterOperator.Equals,
          proxy?.$ms.constant.FilterOperator.NotEquals,
          // proxy?.$ms.constant.FilterOperator.Between,
          proxy?.$ms.constant.FilterOperator.LessThan,
          proxy?.$ms.constant.FilterOperator.LessThanEquals,
          proxy?.$ms.constant.FilterOperator.GreaterThan,
          proxy?.$ms.constant.FilterOperator.GreaterThanEquals,
          proxy?.$ms.constant.FilterOperator.Null,
          proxy?.$ms.constant.FilterOperator.NotNull,
        ];
      case proxy.$ms.constant.FormatType.Date:
      case proxy.$ms.constant.FormatType.DateTime:
      case proxy.$ms.constant.FormatType.Time:
        return [
          proxy?.$ms.constant.FilterOperator.Equals,
          proxy?.$ms.constant.FilterOperator.NotEquals,
          // proxy?.$ms.constant.FilterOperator.Between,
          proxy?.$ms.constant.FilterOperator.LessThan,
          proxy?.$ms.constant.FilterOperator.LessThanEquals,
          proxy?.$ms.constant.FilterOperator.GreaterThan,
          proxy?.$ms.constant.FilterOperator.GreaterThanEquals,
          proxy?.$ms.constant.FilterOperator.Null,
          proxy?.$ms.constant.FilterOperator.NotNull,
        ];
      case proxy.$ms.constant.FormatType.Checkbox:
        return [proxy?.$ms.constant.FilterOperator.Equals, proxy?.$ms.constant.FilterOperator.NotEquals];
      default:
        return filterTextData;
    }
  };

  /**
   * Lấy loại filter để hiển thị lên header
   * @param {*} col
   * @returns
   * HTHIEP 11.03.2022
   */
  const getFilterType = col => {
    let columnType = getColumnOptionType(col);

    if (typeof columnType === 'undefined' || columnType == null) {
      return proxy.$ms.constant.FilterType.msThText;
    }

    switch (columnType) {
      case proxy.$ms.constant.FormatType.Enum:
        return proxy.$ms.constant.FilterType.msThEnum;
      case proxy.$ms.constant.FormatType.Combobox:
      case proxy.$ms.constant.FormatType.ComboboxAmount:
        return proxy.$ms.constant.FilterType.msThCombobox;
      case proxy.$ms.constant.FormatType.ComboboxMultiple:
        return proxy.$ms.constant.FilterType.msThComboboxMultiple;
      case proxy.$ms.constant.FormatType.Number:
      case proxy.$ms.constant.FormatType.UnitPrice:
      case proxy.$ms.constant.FormatType.Amount:
      case proxy.$ms.constant.FormatType.Rate:
      case proxy.$ms.constant.FormatType.ExchangeRate:
      case proxy.$ms.constant.FormatType.UnitPriceOC:
      case proxy.$ms.constant.FormatType.AmountOC:
      case proxy.$ms.constant.FormatType.Allocation:
      case proxy.$ms.constant.FormatType.QuantityConvert:
      case proxy.$ms.constant.FormatType.Quantity:
      case proxy.$ms.constant.FormatType.NumYear:
        return proxy.$ms.constant.FilterType.msThNumber;
      case proxy.$ms.constant.FormatType.Date:
      case proxy.$ms.constant.FormatType.DateTime:
      case proxy.$ms.constant.FormatType.Time:
        return proxy.$ms.constant.FilterType.msThDate;
      case proxy.$ms.constant.FormatType.Checkbox:
        return proxy.$ms.constant.FilterType.msThBoolean;
      case proxy.$ms.constant.FormatType.State:
        return proxy.$ms.constant.FilterType.msThState;
      default:
        return proxy.$ms.constant.FilterType.msThText;
    }
  };
  /**
   * Emit event cha hứng
   * @param {*} value
   * HTHIEP 11.03.2022
   * @modifier NXHung 18.01.2024 Bổ sung trường hợp filter 1 cột nhiều điều kiện
   */
  const filterHeaderHandle = input => {
    //  Nếu là luồng nhiều điều kiện
    if (Array.isArray(input)) {
      proxy.col.filter = [];

      // Thực hiện filter nếu giá trị filter thay đổi,
      // hoặc giá trị operator thay đổi và giá trị filter không khác trắng hoặc operator bằng null hoặc not null
      input.forEach(function (item, index) {
        let { field, operator, value } = item;

        if (
          operator === 'remove' ||
          value ||
          operator === proxy?.$ms.constant.FilterOperator.Null ||
          operator === proxy?.$ms.constant.FilterOperator.NotNull
        ) {
          let filterObj = {};

          filterObj.field = field;

          if (operator) {
            filterObj.operator = operator;
          }

          // Thêm fix giá trị để điều kiện lọc NULL hoặc NOT NULL sẽ không bị xóa
          // tbngoc 27.07.2022
          if (
            operator === proxy?.$ms.constant.FilterOperator.Null ||
            operator === proxy?.$ms.constant.FilterOperator.NotNull
          ) {
            value = 'text';
          }
          filterObj.value = value;

          proxy.col.filter.push(filterObj);
        }
      });

      emit('filter-header', proxy.col.filter);
    }
    //  Luồng cũ 1 điều kiện
    else {
      let { operator, value } = input;
      if (!proxy.col.filter || typeof proxy.col.filter != 'object' || value == '') {
        proxy.col.filter = {};
      }

      // Thực hiện filter nếu giá trị filter thay đổi,
      // hoặc giá trị operator thay đổi và giá trị filter không khác trắng hoặc operator bằng null hoặc not null
      if (
        operator === 'remove' ||
        value !== proxy.col.filter.value ||
        (proxy.col.filter.operator !== operator &&
          (value ||
            operator === proxy?.$ms.constant.FilterOperator.Null ||
            operator === proxy?.$ms.constant.FilterOperator.NotNull))
      ) {
        if (operator) {
          // Kiểm tra nếu filter là mảng
          if (Array.isArray(proxy.col.filter)) {
            proxy.col.filter.forEach(filterItem => {
              filterItem.operator = operator;
            });
          } else {
            proxy.col.filter.operator = operator;
          }
        }
        // Thêm fix giá trị để điều kiện lọc NULL hoặc NOT NULL sẽ không bị xóa
        // tbngoc 27.07.2022
        if (
          operator === proxy?.$ms.constant.FilterOperator.Null ||
          operator === proxy?.$ms.constant.FilterOperator.NotNull
        ) {
          value = 'text';
        }
        proxy.col.filter.value = value;
        emit('filter-header', value);
      }
    }
  };

  /**
   * Emit event cha hứng combo enum
   * @param {*} value
   * NXCHIEN 07.06.2022
   */
  const filterHeaderHandleEnum = (newData, { operator, value }) => {
    if (!proxy.col.filter) {
      proxy.col.filter = {};
    }

    if (!newData) {
      value = null;
    }

    // Thực hiện filter nếu giá trị filter thay đổi,
    // hoặc giá trị operator thay đổi và giá trị filter không khác trắng hoặc operator bằng null hoặc not null
    if (
      operator === 'remove' ||
      value !== proxy.col.filter.value ||
      (proxy.col.filter.operator !== operator &&
        (value ||
          operator === proxy?.$ms.constant.FilterOperator.Null ||
          operator === proxy?.$ms.constant.FilterOperator.NotNull))
    ) {
      // NVTUAN1 08.07.2022: Nếu là tất cả thì remove filter
      //nếu trường hợp lấy trạng thái hồ sơ từ kho bạc với trạng thái 'chờ kế toán trưởng phê duyệt' thì không chuyển thành remove-htthoa 26.10.2023
      // Xử lý bug 77376 - tvtoan 07.03.2024
      if (value === -1 && newData.enumKey != 'CompanyChiefAccountantReject' && newData.enumKey != 'Record') {
        operator = 'remove';
      }

      if (operator) {
        proxy.col.filter.operator = operator;
      }
      proxy.col.filter.value = value;
      emit('filter-header', value);
    }
  };

  /**
   * Xóa giá trị filter ở ô hiện tại
   * HTHIEP 14.03.2022
   */
  const removeFilter = trigger => {
    if (typeof proxy.filterValue !== 'undefined') {
      setDefaultFilter();
      if (trigger) {
        emit('filter-header', proxy.filterValue);
      }
    }
  };

  /**
   * Set giá trị khi filter trống
   * HTHIEP 14.03.2022
   * NCPHUOC 28/04/2022: Xóa value enum
   */
  const setEmptyFilterValue = () => {
    const columnType = getColumnOptionType(props.col);
    switch (columnType) {
      case proxy.$ms.constant.FormatType.Enum:
      case proxy.$ms.constant.FormatType.Combobox:
      case proxy.$ms.constant.FormatType.ComboboxAmount:
      case proxy.$ms.constant.FormatType.ComboboxMultiple:
        filterValue.value = '';
        if (thEnum.value && typeof thEnum.value.reset === 'function') {
          thEnum.value.reset();
        }
        break;

      case proxy.$ms.constant.FormatType.Number:
      case proxy.$ms.constant.FormatType.UnitPrice:
      case proxy.$ms.constant.FormatType.Amount:
      case proxy.$ms.constant.FormatType.Rate:
      case proxy.$ms.constant.FormatType.ExchangeRate:
      case proxy.$ms.constant.FormatType.UnitPriceOC:
      case proxy.$ms.constant.FormatType.AmountOC:
      case proxy.$ms.constant.FormatType.Allocation:
      case proxy.$ms.constant.FormatType.QuantityConvert:
      case proxy.$ms.constant.FormatType.Quantity:
        filterValue.value = '';
        // proxy.filterValue = "";
        break;
      case proxy.$ms.constant.FormatType.Date:
      case proxy.$ms.constant.FormatType.DateTime:
      case proxy.$ms.constant.FormatType.Time:
      case proxy.$ms.constant.FormatType.Checkbox:
        filterValue.value = null;
        // proxy.filterValue = null;
        break;
      default:
        filterValue.value = '';
        // proxy.filterValue = "";
        break;
    }
  };
  /**
   * Gán filter mặc định cho column
   * HTHIEP 14.03.2022: Bốc từ bên gridview sang bên từng cột filter
   * NCPHUOC 23/06/2022: Sửa lại cấu hình default operator theo từng column type
   * NVTUAN1 27.07.2022: Sửa lại cấu hình default operator = Equals cho column có FormatType là Enum
   */
  const setDefaultFilter = () => {
    if (!proxy.col.filter) {
      proxy.col.filter = {};
    }

    // NMDUC1 - Sửa lỗi bộ lọc mặc định không khớp với icon lọc mặc định
    // Với trường hợp không truyền formatType, bộ lọc mặc định là "Bằng" => sai
    // Sửa bộ lọc mặc định là "Chứa", case các trường hợp cần trả về bộ lọc "Bằng"
    // Bug 61816, 61856
    operatorValue.value = proxy.$ms.constant.FilterOperator.Contains;
    proxy.col.filter = { value: null, operator: proxy.$ms.constant.FilterOperator.Contains };

    switch (proxy.col.formatType) {
      case proxy.$ms.constant.FormatType.Text:
      case proxy.$ms.constant.FormatType.Html:
      case proxy.$ms.constant.FormatType.TextArea:
      case proxy.$ms.constant.FormatType.ComboboxMultiple:
        operatorValue.value = proxy.$ms.constant.FilterOperator.Contains;
        proxy.col.filter = { value: null, operator: proxy.$ms.constant.FilterOperator.Contains };
        break;
      case proxy.$ms.constant.FormatType.Number:
      case proxy.$ms.constant.FormatType.NumYear:
      case proxy.$ms.constant.FormatType.Amount:
      case proxy.$ms.constant.FormatType.AmountOC:
      case proxy.$ms.constant.FormatType.UnitPrice:
      case proxy.$ms.constant.FormatType.UnitPriceOC:
      case proxy.$ms.constant.FormatType.Rate:
      case proxy.$ms.constant.FormatType.ExchangeRate:
      case proxy.$ms.constant.FormatType.Quantity:
      case proxy.$ms.constant.FormatType.QuantityConvert:
      case proxy.$ms.constant.FormatType.Checkbox:
      case proxy.$ms.constant.FormatType.Date:
      case proxy.$ms.constant.FormatType.DateTime:
      case proxy.$ms.constant.FormatType.Enum:
      case proxy.$ms.constant.FormatType.Order:
      case proxy.$ms.constant.FormatType.Combobox: // gán lại mặc định operator = Equals vs filter vs formatType Combobox nhhoang1 23.08.2023
      case proxy.$ms.constant.FormatType.ComboboxAmount:
        operatorValue.value = proxy.$ms.constant.FilterOperator.Equals;
        proxy.col.filter = { value: null, operator: proxy.$ms.constant.FilterOperator.Equals };
        break;
    }

    // set icon hiện thị về giá trị mặc định nhhoang1 23.08.2023
    nativeFilterIconClass.value = props.filterIconClass;

    // Set giá trị về trắng khi removeFilter
    setEmptyFilterValue();
  };

  /**
   * Lấy dữ liệu operators bind lên menu dropdown
   * @param {*} enumName
   * @param {*} values
   * @return Mảng operators
   * HTHIEP 18.03.2022
   */
  const getFilterOperators = (enumName, values) => {
    const e = MSConstant[enumName];
    const arr = [];
    if (e) {
      for (const key in e) {
        if (typeof e[key] !== 'undefined') {
          const v = e[key];
          let ix = -1;
          if (!values || (ix = values.indexOf(v)) > -1) {
            const enumText = i18n.t('i18nEnum.' + enumName + '.' + key);

            const item = {
              enumValue: v,
              enumKey: key,
              enumText: enumText,
              icon: getFilterOperatorIcon(v),
            };

            if (ix > -1) {
              if (arr[ix]) {
                arr[arr.length] = item;
              } else {
                arr[ix] = item;
              }
            } else {
              arr.push(item);
            }
          }
        }
      }
    }
    arr.push({
      enumValue: 'remove',
      enumKey: 'remove',
      enumText: 'Xóa điều kiện lọc',
      icon: 'ic-filter-remove',
    });
    return arr;
  };

  /**
   * Lấy thông tin icon class theo loại operator
   * @param {*} key
   * @return
   * HTHIEP 18.03.2022
   */
  const getFilterOperatorIcon = key => {
    switch (key) {
      case proxy?.$ms.constant.FilterOperator.Contains:
        return 'ic-filter-contain';
      case proxy?.$ms.constant.FilterOperator.Notcontains:
        return 'ic-filter-not-contain';
      case proxy?.$ms.constant.FilterOperator.StartsWith:
        return 'ic-filter-start-with';
      case proxy?.$ms.constant.FilterOperator.EndsWith:
        return 'ic-filter-ends-with';
      case proxy?.$ms.constant.FilterOperator.Null:
        return 'ic-filter-null';
      case proxy?.$ms.constant.FilterOperator.NotNull:
        return 'ic-filter-not-null';
      case proxy?.$ms.constant.FilterOperator.Equals:
        return 'ic-filter-equal';
      case proxy?.$ms.constant.FilterOperator.NotEquals:
        return 'ic-filter-not-equal';
      case proxy?.$ms.constant.FilterOperator.GreaterThan:
        return 'ic-filter-greater-than';
      case proxy?.$ms.constant.FilterOperator.GreaterThanEquals:
        return 'ic-filter-greater-than-or-eq';
      case proxy?.$ms.constant.FilterOperator.LessThan:
        return 'ic-filter-less-than';
      case proxy?.$ms.constant.FilterOperator.LessThanEquals:
        return 'ic-filter-less-than-or-eq';
      default:
        return 'ic-filter-contain';
    }
  };

  // Hooks
  onMounted(() => {
    nativeFilterIconClass.value = props.filterIconClass;
  });
  /**
   * Gán dữ liệu cho dropdown operator
   * HTHIEP 14.03.2022
   */
  onMounted(() => {
    let operators = [];
    if (
      proxy.col &&
      typeof proxy?.col.operators !== 'undefined' &&
      Array.isArray(proxy?.col.operators) &&
      proxy.col.operators.length > 0
    ) {
      operators = [...proxy?.col.operators];
    } else {
      operators = [...operators, ...getFilterData(props.col)];
    }
    filterOperators.value = getFilterOperators('FilterOperator', operators);
  });

  /**
   * Set giá trị mặc định cho filter
   * HTHIEP 14.03.2022
   */
  onMounted(() => {
    setDefaultFilter();
  });

  /**
   * Thay đổi trạng thái của ô input khi đổi operator
   * HTHIEP 14.03.2022
   */
  watch(
    operatorValueReadonly,
    newValue => {
      if (newValue) {
        if (filterInput.value) {
          filterInput.value.$el.querySelector('input').setAttribute('readOnly', true);
          setEmptyFilterValue();
        }
      } else {
        if (filterInput.value) {
          filterInput.value.$el.querySelector('input').removeAttribute('readOnly');
        }
      }
    },
    {
      immediate: true,
    },
  );

  /**
   * Xem thay đổi của operator để thay đổi trạng thái của ô input
   * HTHIEP 14.03.2022
   */
  watch(
    operatorValue,
    newValue => {
      switch (newValue) {
        case proxy.$ms.constant.FilterOperator.Null:
        case proxy.$ms.constant.FilterOperator.NotNull:
          operatorValueReadonly.value = true;
          break;
        default:
          operatorValueReadonly.value = false;
          break;
      }
    },
    {
      immediate: true,
    },
  );

  /**
   * Cập nhật giá trị filter mà không emit event
   * @param {*} value - Giá trị filter
   * @param {*} operator - Operator filter
   * @param {*} emitFilter - Có emit filter event không
   * HTHIEP 2024
   */
  const updateFilterValue = (value, operator = null, emitFilter = false) => {
    // Cập nhật giá trị
    if (value !== undefined) {
      filterValue.value = value;
    }

    if (operator !== null) {
      operatorValue.value = operator;
    }

    // Cập nhật filter object
    if (!proxy.col.filter) {
      proxy.col.filter = {};
    }

    proxy.col.filter.value = filterValue.value;
    proxy.col.filter.operator = operatorValue.value;
    proxy.col.filter.field = proxy.col.dataField;

    // Emit filter event nếu cần
    if (emitFilter) {
      emit('filter-header', proxy.col.filter);
    }
  };

  return {
    nativeFilterIconClass,
    operatorValue,
    filterOperators,
    operatorValueReadonly,
    filterValue,
    filterInput,
    getFilterData,
    filterHeaderHandle,
    filterHeaderHandleEnum,
    filterOperatorItemClick,
    getFilterType,
    removeFilter,
    thEnum,
    updateFilterValue,
  };
}

export default setup;
